export default __webpack_public_path__ + "static/media/dec2023-2.7bad9f46.jpg";